import React, { useState, useEffect } from 'react';

const Stopwatch = () => {
  // 初始化秒数、分钟数和小时数的状态
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);

  useEffect(() => {
    // 设置定时器，每秒执行一次
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 59) {
          setMinutes((prevMinutes) => {
            if (prevMinutes === 59) {
              setHours((prevHours) => prevHours + 1);
              return 0;
            }
            return prevMinutes + 1;
          });
          return 0;
        }
        return prevSeconds + 1;
      });
    }, 1000);

    // 清理函数，在组件卸载时清除定时器
    return () => clearInterval(interval);
  }, []);

  // 格式化数字，确保显示为两位
  const formatTime = (time) => {
    return time.toString().padStart(2, '0');
  };

  return (
    <span>
      {/* 显示计时结果，格式为 00:00:00 */}
      <span>{formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}</span>
    </span>
  );
};

export default Stopwatch;